export default __webpack_public_path__ + "static/media/beforemembership.691abc1b.jpg";